import React from "react"

export const SubordinationIcon = (props) => {
  return (
    <svg width={24} height={24} xmlns="http://www.w3.org/2000/svg" {...props}>
      <g fill="#034055" fillRule="evenodd">
        <path
          fillRule="nonzero"
          d="M14.514 11.625H3v2.75h11.514V18.5L20 13l-5.486-5.5z"
        />
        <path d="M6 5v8H3V5z" />
      </g>
    </svg>
  )
}
